import {
  IThemeInitalState,
  IBorderRadiusInitialState,
  IBackgroundInitialState,
  IFontInitialState,
  IBorderInitialState,
  IFontInitialStateProps,
} from "./interface";
import theme from "@theme/overrides/theme";

const backgroundInitialState = (
  data: IBackgroundInitialState
): IBackgroundInitialState => {
  const { type, imageUrl, patternId, color } = data;
  return {
    type: type ?? "PATTERN",
    imageUrl: imageUrl ?? "",
    patternId: patternId ?? "",
    color: color ?? "",
  };
};
const borderRadiusInitialState = (
  data: IBorderRadiusInitialState
): IBorderRadiusInitialState => {
  const { topLeft, topRight, bottomLeft, bottomRight } = data;
  return {
    topLeft: topLeft ?? "0",
    topRight: topRight ?? "0",
    bottomLeft: bottomLeft ?? "0",
    bottomRight: bottomRight ?? "0",
  };
};
const fontInitialState = (props: IFontInitialStateProps): IFontInitialState => {
  const { style, family, color, size } = props ?? {};
  return {
    color: color ?? theme.color.defaultTextColor,
    family: family ?? "'Nunito Sans', sans-serif",
    style: style ?? "REGULAR",
    size: size ?? "12",
  };
};
const borderInitialState = (data: IBorderInitialState): IBorderInitialState => {
  const { borderStyle, borderColor, borderWidth } = data;
  return {
    borderStyle: borderStyle ?? "SOLID",
    borderColor: borderColor ?? theme.color.defaultBorderColor,
    borderWidth: borderWidth ?? {
      left: "0",
      right: "0",
      top: "0",
      bottom: "0",
    },
  };
};

export const themeInitialState = (): IThemeInitalState => {
  return {
    themeId: "",
    formId: "",
    name: "",
    description: "",
    background: backgroundInitialState({
      type: "COLOR",
    }),
    width: "700",
    logoWidth:"",
    activeAlignment:"" ,
    header: {
      background: backgroundInitialState({
        type: "COLOR",
        color: theme.color.secondary200,
      }),
      color: theme.color.defaultTextColor,
      borderRadius: borderRadiusInitialState({
        topLeft: "8",
        topRight: "8",
        bottomLeft: "0",
        bottomRight: "0",
      }),
      fontTitle: fontInitialState({ style: "BOLD", size: "20" }),
      fontDescription: fontInitialState({ style: "REGULAR", size: "14" }),
      textAlignment: "LEFT",
      border: borderInitialState({
        borderStyle: "NONE",
        borderColor: theme.color.defaultBorderColor,
        borderWidth: {
          left: "0",
          right: "0",
          top: "0",
          bottom: "0",
        },
      }),
    },
    footer: {
      background: backgroundInitialState({
        type: "COLOR",
      }),
      textAlignment: "LEFT",
      color: "",
      borderRadius: borderRadiusInitialState({
        topLeft: "8",
        topRight: "8",
        bottomLeft: "8",
        bottomRight: "8",
      }),
      font: fontInitialState({}),
      border: borderInitialState({
        borderStyle: "NONE",
        borderColor: theme.color.defaultBorderColor,
        borderWidth: {
          left: "0",
          right: "0",
          top: "0",
          bottom: "0",
        },
      }),
    },
    section: {
      background: backgroundInitialState({
        type: "COLOR",
        color: "#ffffff",
      }),
      textAlignment: "LEFT",
      color: "",
      borderRadius: borderRadiusInitialState({
        topLeft: "8",
        topRight: "8",
        bottomLeft: "8",
        bottomRight: "8",
      }),
      fontTitle: fontInitialState({ style: "BOLD", size: "16" }),
      fontDescription: fontInitialState({ style: "REGULAR", size: "12" }),
      border: borderInitialState({
        borderStyle: "DASHED",
        borderColor: theme.color.primary,
        borderWidth: {
          left: "1",
          right: "1",
          top: "1",
          bottom: "1",
        },
      }),
    },
    page: {
      background: backgroundInitialState({
        type: "COLOR",
        color: "#ffffff",
      }),
      textAlignment: "LEFT",
      color: "",
      borderRadius: borderRadiusInitialState({
        topLeft: "16",
        topRight: "16",
        bottomLeft: "16",
        bottomRight: "16",
      }),
      fontTitle: fontInitialState({ style: "BOLD", size: "18" }),
      fontDescription: fontInitialState({ style: "REGULAR", size: "14" }),
      border: borderInitialState({
        borderStyle: "NONE",
        borderColor: theme.color.defaultBorderColor,
        borderWidth: {
          left: "0",
          right: "0",
          top: "0",
          bottom: "0",
        },
      }),
    },
    field: {
      alignment: "COLUMN",
      spacing: {
        left: "6",
        right: "6",
        top: "6",
        bottom: "6",
      },
      fontTitle: fontInitialState({}),
      fontDescription: fontInitialState({}),
    },
  };
};
